<template>
  <a-layout-content class="overflow-hidden">
    <div class="filter-panel">
      <a-row>
        <a-col :span="24" class="other-filter">
          <div class="mr-20">关键字:</div>
          <a-input class="mr-20" placeholder="关键字" style="width: 360px" v-model="keyword" />
          <a-button class="mr-20 view-btn large" html-type="submit" @click="getList(true)">搜索</a-button>
          <a-button class="mr-20 view-btn large" html-type="submit" @click="reset">重置</a-button>
        </a-col>
      </a-row>
    </div>
    <a-divider></a-divider>
    <div class="flex-container filter-panel filter-panel2">
      <sub-title>数据列表</sub-title>
    </div>
    <a-divider></a-divider>
    <a-table :columns="columns" :dataSource="logs" :rowKey="(record) => record.id+'_'+record.fullUnitName" :loading="loading"
      :scroll="{ x: 1500, y: 800 }" v-if="logs && logs.length > 0" :pagination="pagination" @change="onPageChange">
      <template slot="showTitle" slot-scope="text, record" ellipsis="...">
        <div :title="text">{{ text }}</div>
      </template>

      <template slot="showStatus" slot-scope="text, record" ellipsis="...">
        <span v-if="text">删除</span>
        <span v-else>正常</span>
      </template>

      <template slot="showType" slot-scope="text, record" ellipsis="...">
        <span>{{getType(text)}}</span>
      </template>

      <template slot="showMaterial" slot-scope="text, record" ellipsis="...">
        <span :title="getMaterial(record)">{{getMaterial(record)}}</span>
      </template>

      <template slot="showPicSlot" slot-scope="text, record" ellipsis="...">
        <span v-if="text && text.length > 2">
          <a-icon @click="showPic(text)" type="check-circle" theme="twoTone" two-tone-color="#52c41a"
            :style="{ fontSize: '20px' }" />
        </span>
        <span v-else>
          <a-icon type="close-circle" theme="twoTone" two-tone-color="red" :style="{ fontSize: '20px' }" />
        </span>
      </template>

      <template slot="operation" slot-scope="text, record">
        <!-- <a @click="showDept(record)" href="javascript:;">编辑</a> | -->
      </template>
    </a-table>
    <!-- 列表表格 -->

    <!-- 证件材料预览 -->
    <a-modal v-if="preview_visible" v-model="preview_visible" :zIndex="2" width="900px" :maskClosable="false"
      :footer="null">
      <div height="325px" width="450px">
        <img :src="url" width="100%" height="100%" />
      </div>
    </a-modal>
  </a-layout-content>
</template>
<script>
import SubTitle from "@/components/common/subTitle";
import { Divider, Modal } from "ant-design-vue";
import { userListPage } from "@/api";
import moment from "moment";
import { getUserInfo,types } from "@/plugins/common";
export default {
  components: {
    SubTitle,
    ADivider: Divider,
    Modal,
  },
  data() {
    return {
      types,
      // 显示列
      columns: [
        /*{
          title: "id",
          width: 100,
          dataIndex: "id",
          key: "id",
        },*/
        {
          title: "供应商",
          width: 200,
          dataIndex: "fullUnitName",
          key: "fullUnitName",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "社会统一信用代码",
          width: 150,
          dataIndex: "uniqueNo",
          key: "uniqueNo",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "营业执照",
          width: 40,
          dataIndex: "license",
          key: "license",
          scopedSlots: { customRender: "showPicSlot" },
        },
        {
          title: "授权委托书",
          width: 60,
          dataIndex: "authorization",
          key: "authorization",
          scopedSlots: { customRender: "showPicSlot" },
        },
        {
          title: "负责人姓名",
          width: 100,
          dataIndex: "cname",
          key: "cname",
        },
        {
          title: "联系电话",
          width: 100,
          dataIndex: "name",
          key: "name",
        },
        /*{
          title: "供应商类型",
          width: 180,
          dataIndex: "supplierType",
          key: "supplierType",
          scopedSlots: { customRender: "showTitle" },
        },*/
        {
          title: "状态",
          width: 70,
          dataIndex: "deleted_at",
          key: "deleted_at",
          scopedSlots: { customRender: "showStatus" },
        },
        {
          title: "类型",
          width: 70,
          dataIndex: "type",
          key: "type",
          scopedSlots: { customRender: "showType" },
        },
        {
          title: "物料",
          width: 170,
          dataIndex: "userExts",
          key: "userExts",
          scopedSlots: { customRender: "showMaterial" },
        },
      ],
      // 部门集合
      logs: [],
      pagination: {
        total: 0,
        current: 1,
        showTotal: (total) => {
          return `共 ${total} 条`;
        },
      },
      queryParams: {
        limit: 10,
        page: 0,
        searchCondition: {},
      },
      loading: false,
      keyword: "",

      url: "",
      preview_visible: false
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    moment,
    getList(flag) {
      if (this.loading) return;
      this.loading = true;
      if( flag == true ) {
          this.pagination.current = 1;
      }
      this.queryParams.page = this.pagination.current - 1;

      if (this.keyword) {
        this.queryParams.searchCondition.keyword = this.keyword;
      } else {
        delete this.queryParams.searchCondition.keyword;
      }

      userListPage(this.queryParams)
        .then((res) => {
          console.log(res);
          this.logs = res.list;
          this.pagination.total = res.total;
        })
        .finally((res) => {
          this.loading = false;
        });
    },
    onPageChange(pagination, filters, sorter) {
      this.pagination = pagination;
      this.queryParams.page = pagination.current - 1;
      this.getList();
    },

    reset() {
      // clear conditions
      this.keyword = "";
      this.pagination.current = 1;
      this.queryParams.page = 0;
      this.getList();
    },

    showPic(url) {
      console.log(url);
      this.url = JSON.parse(url)[0];
      if( this.url.endsWith(".pdf") ) {
        window.open(this.url);
      } else {
        this.preview_visible = true;
      }
    },

    getType(type) {
      for(let i = 0;i < types.length;i ++) {
        if( type == types[i].id ) {
          return types[i].name;
        }
      }
      return type;
    },

    getMaterial(record) {
      try {
        let exts = record.userExts;
        let material = [];
        if( exts ) {
          exts.forEach(function(item,idx){
            material.push(item.materialName);
          });
        }
        return material.join(",");
      }catch(e){
        console.log(e);
      }
      return "";
    }

    //
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/style.scss";

.other-filter {
  display: flex;
  height: 50px;
  align-items: center;

  .mr-20 {
    margin-right: 20px;
  }
}

.icons-list :deep(.anticon) {
  margin-right: 6px;
  font-size: 24px;
}
</style>

